import { render } from "./NiifNotas.vue?vue&type=template&id=426a5926"
import script from "./NiifNotas.vue?vue&type=script&lang=js"
export * from "./NiifNotas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__